module.exports = __webpack_public_path__ + "img/circle-info-solid.e7fb395e.svg";